export interface IExchData {
  exchId: string | number
  exchName: string
  exchUrl: string
  exchCode: string
  heatIndex: number | string
  exchNumCurrencies: number | string
  exchNumMarkets: number | string
  exchVolume24: number | string
  exchVolume1: number | string
  exchBalanceEnabledV2: boolean | string
  exchTradeEnabledV2: boolean | string
  hasSpotTrading: boolean | string
  hasFuturesTrading: boolean | string
  exchHasWhitelisting: boolean | string
  slug: string
  trafficRank: number | string
  trafficRank90dChange: number | string
}

export class ExchData implements IExchData {
  constructor(
    public exchId: string | number = '',
    public exchName: string = '',
    public exchUrl: string = '',
    public exchCode: string = '',
    public heatIndex: number | string = '',
    public exchNumCurrencies: number | string = '',
    public exchNumMarkets: number | string = '',
    public exchVolume24: number | string = '',
    public exchVolume1: number | string = '',
    public exchBalanceEnabledV2: boolean | string = '',
    public exchTradeEnabledV2: boolean | string = '',
    public hasSpotTrading: boolean | string = '',
    public hasFuturesTrading: boolean | string = '',
    public exchHasWhitelisting: boolean | string = '',
    public slug: string = '',
    public trafficRank: number | string = '',
    public trafficRank90dChange: number | string = ''
  ) {}
}

export default ExchData 